<div class="title">
	{{ 'campaigns.totalRecipients' | translate }}
	<div class="total">{{ totalRecipients }}</div>
</div>

<div class="content">
	<tui-ring-chart [(activeItemIndex)]="activeItemIndex" [value]="value"></tui-ring-chart>
	<div class="legend">
		@for (label of labels; let index = $index; track index) {
			<tui-legend-item
				(mouseleave)="makeNaN()"
				(mouseover)="onHover(index, $event)"
				[active]="isItemActive(index)"
				[color]="getColor(index)"
				[text]="label | translate"
				class="item"
				size="s"
			>
				<b>{{ value[index] || 0 }}</b>
			</tui-legend-item>
		}
	</div>
</div>
